import { supabase } from '@/lib/supabase'

export const signIn = async (email, password) => {
  const { data, error } = await supabase.auth.signInWithPassword({ email, password })
  if (error) return { success: false, error: error.message }
  return { success: true, user: data.user, session: data.session }
}

export const signOut = async () => {
  const { error } = await supabase.auth.signOut()
  if (error) return { success: false, error: error.message }
  return { success: true }
}

export const getCurrentUser = async () => {
  const { data: { user }, error } = await supabase.auth.getUser()
  if (error) return null
  return user
}

export const onAuthStateChange = (callback) =>
  supabase.auth.onAuthStateChange((event, session) => callback(event, session))
